<template>
  <section class="builders-section">
    <div class="container">
      <span class="section-tag">PARTNERS</span>
      <h2 class="section-title">Associated Builders</h2>
      <p class="section-subtitle">
        Collaborating with premier developers to bring you top-tier residential
        projects.
      </p>

      <div class="builders-grid">
        <router-link
          v-for="builder in builders"
          :key="builder.name"
          to="/associatedbuilders"
          class="builder-card"
        >
          <div class="card-image-wrapper">
            <img :src="builder.image" :alt="builder.name" />
          </div>
          <div class="card-content">
            <div class="text-wrapper">
              <h3>{{ builder.name }}</h3>
              <p>{{ builder.description }}</p>
            </div>
            <span class="read-more">Learn More →</span>
          </div>
        </router-link>
      </div>

      <div class="view-all-container">
        <router-link to="/associatedbuilders" class="btn-primary"
          >View All Partners</router-link
        >
      </div>
    </div>
  </section>
</template>

<script setup>
import orchidImg from '@/assets/images/OrchidGreens.jpg';
import nobleImg from '@/assets/images/NobleWillasa.jpg';
import bjbfImg from '@/assets/images/BjbfBuilders&Developers.jpeg';

const builders = [
  {
    name: 'Orchid Greens',
    description:
      'Luxurious living spaces designed with modern architecture and green landscapes.',
    image: orchidImg,
  },
  {
    name: 'Noble Willasa',
    description:
      'Premium residential projects featuring top-notch amenities and strategic locations.',
    image: nobleImg,
  },
  {
    name: 'BJBF Builders',
    description:
      'Committed to delivering high-quality construction and timely possession.',
    image: bjbfImg,
  },
];
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.builders-section {
  padding: 80px 0;
  background: #f9fafb; /* Light grey background for contrast */
  text-align: center;
}

.section-tag {
  color: #b91c1c;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 0.9rem;
}

.section-title {
  font-size: 2.5rem;
  margin: 10px 0 15px;
  color: #111;
  font-weight: 800;
}

.section-subtitle {
  color: #666;
  max-width: 600px;
  margin: 0 auto 50px;
  line-height: 1.6;
}

.builders-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  text-align: left;
}

.builder-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  text-decoration: none;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.builder-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.card-image-wrapper {
  height: 220px;
  overflow: hidden;
}

.card-image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.builder-card:hover .card-image-wrapper img {
  transform: scale(1.05);
}

.card-content {
  padding: 25px;
  display: flex;
  flex-direction: column;
  flex-grow: 1; /* Ensures content stretches to bottom */
}

.text-wrapper {
  flex-grow: 1; /* Pushes read more to bottom */
}

.card-content h3 {
  font-size: 1.5rem;
  margin: 0 0 10px 0;
  color: #111;
  font-weight: 700;
}

.card-content p {
  font-size: 0.95rem;
  color: #555;
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.read-more {
  color: #b91c1c;
  font-weight: 600;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.view-all-container {
  margin-top: 60px;
}

.btn-primary {
  display: inline-block;
  background: #b91c1c;
  color: white;
  padding: 16px 40px;
  text-decoration: none;
  font-weight: bold;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.btn-primary:hover {
  background: #991b1b;
}
</style>
